import React, { FunctionComponent } from 'react';
import { Body } from 'js/design_system/Body';
import styled from 'astroturf/react';

const RequiredFields = styled(Body)`
  display: inline-flex;
  padding: 5px 8px 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--stroke-dark, #223);
`;

export const RequiredFieldsLabel: FunctionComponent = (props) => {
  return (
    <RequiredFields as="div" {...props}>
      * Required fields
    </RequiredFields>
  );
};
